// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_PromotionsEngine_Tools_Assignment from "../Restaumatic.PromotionsEngine.Tools.Assignment/index.js";
import * as Restaumatic_PromotionsEngine_Tools_PromotionEvaluation from "../Restaumatic.PromotionsEngine.Tools.PromotionEvaluation/index.js";
var userSelectProductItemKey = function (dictOrd) {
    return function (promotionalItem) {
        return function (productItemKey) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkUserEnabledDefault)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setAssignment(dictOrd)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkAssignmentToProduct(productItemKey))(promotionalItem));
        };
    };
};
var userSelectCart = function (dictOrd) {
    return function (promotionalItem) {
        return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkUserEnabledDefault)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setAssignment(dictOrd)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkAssignmentToCart)(promotionalItem));
    };
};
var updatePromotionalItem = function (promotionalItems) {
    return function (promotionalItem) {
        var updateIfMatch = function (item) {
            var $23 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId(item) === Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId(promotionalItem);
            if ($23) {
                return promotionalItem;
            };
            return item;
        };
        return Data_Functor.map(Data_Functor.functorArray)(updateIfMatch)(promotionalItems);
    };
};
var updateMaybePromotionalItem = function (promotionalItems) {
    var $37 = Data_Maybe.fromMaybe(promotionalItems);
    var $38 = Data_Functor.map(Data_Maybe.functorMaybe)(updatePromotionalItem(promotionalItems));
    return function ($39) {
        return $37($38($39));
    };
};
var oldenUserSelections = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.oldenUserSelection);
var updateOldenMaybePromotionalItem = function (promotionalItems) {
    var olderPromotionalItems = oldenUserSelections(promotionalItems);
    return Data_Functor.map(Data_Maybe.functorMaybe)(updatePromotionalItem(olderPromotionalItems));
};
var nonEnableableProductItemKey = function (itemCand) {
    return function (item) {
        var $24 = !Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWith(itemCand)(item);
        if ($24) {
            return Restaumatic_PromotionsEngine_Cart_PromotionalItem.allocatedProductItemKeys(item);
        };
        return [  ];
    };
};
var filterEnabledByUserItems = /* #__PURE__ */ Data_Array.filter(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabledByUser);
var maybeEnableCartPromotionalItem = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            var $25 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWithAllOthers(promotionalItem)(filterEnabledByUserItems(promotionalItems));
            if ($25) {
                return new Data_Maybe.Just(userSelectCart(dictOrd)(promotionalItem));
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var maybeEnableProductPromotionalItem = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            return function (chooseFrom) {
                var disallowedProductItemKeys = Data_Array.concatMap(nonEnableableProductItemKey(promotionalItem))(filterEnabledByUserItems(promotionalItems));
                var candidateProductItemKeys = Restaumatic_PromotionsEngine_Cart_PromotionalItem.targetProductItemKeys(promotionalItem);
                var availableProductItemKeys = Data_Array.difference(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictOrd.Eq0()))(Data_Array.fromFoldable(Data_Set.foldableSet)(candidateProductItemKeys))(disallowedProductItemKeys);
                var result = Data_Functor.map(Data_Maybe.functorMaybe)(userSelectProductItemKey(dictOrd)(promotionalItem))(chooseFrom(availableProductItemKeys));
                return result;
            };
        };
    };
};
var enabledItems = /* #__PURE__ */ Data_Array.filter(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabled);
var disablePromotionalItem = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            var disabledPromotionalItem = Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkUserDisabled)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.unassign(dictOrd)(promotionalItem));
            return updatePromotionalItem(promotionalItems)(disabledPromotionalItem);
        };
    };
};
var disablePromotionalItemAndEvaluate = function (dictOrd) {
    return function (inputCartData) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                return Restaumatic_PromotionsEngine_Tools_PromotionEvaluation.evaluateEnabledPromotionalItems(dictOrd.Eq0())(inputCartData)(disablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem));
            };
        };
    };
};
var disablePromotionalItemAndRecalculate = function (dictOrd) {
    return function (inputCartData) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                return Restaumatic_PromotionsEngine_Tools_Assignment.assignPromotionalItems(dictOrd)(inputCartData)(disablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem));
            };
        };
    };
};
var compareUserSelectionAge = function (a) {
    return function (b) {
        return Data_Ord.compare(Data_Maybe.ordMaybe(Data_Ord.ordInt))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.selectionAge(a))(Restaumatic_PromotionsEngine_Cart_PromotionalItem.selectionAge(b));
    };
};
var disableOldest = function (promoFilter) {
    return function (assignmentMode) {
        return function (promoItems) {
            var selection = (function () {
                var $26 = Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_CartParams.eqAssignmentMode)(assignmentMode)(Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value);
                if ($26) {
                    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkAutoDisabled;
                };
                return Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkUserDisabled;
            })();
            var oldestItemMb = Data_Foldable.maximumBy(Data_Foldable.foldableArray)(compareUserSelectionAge)(Data_Array.filter(promoFilter)(filterEnabledByUserItems(promoItems)));
            var oldestDisabledItemMb = Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(selection))(oldestItemMb);
            return updateMaybePromotionalItem(promoItems)(oldestDisabledItemMb);
        };
    };
};
var disableOldestAnyItem = /* #__PURE__ */ disableOldest(/* #__PURE__ */ Data_Function["const"](true));
var enableCartPromotionalItem = function ($copy_dictOrd) {
    return function ($copy_assignmentMode) {
        return function ($copy_promotionalItems) {
            return function ($copy_promotionalItem) {
                var $tco_var_dictOrd = $copy_dictOrd;
                var $tco_var_assignmentMode = $copy_assignmentMode;
                var $tco_var_promotionalItems = $copy_promotionalItems;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(dictOrd, assignmentMode, promotionalItems, promotionalItem) {
                    var $27 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWithAllOthers(promotionalItem)(filterEnabledByUserItems(promotionalItems));
                    if ($27) {
                        $tco_done = true;
                        return updatePromotionalItem(promotionalItems)(userSelectCart(dictOrd)(promotionalItem));
                    };
                    $tco_var_dictOrd = dictOrd;
                    $tco_var_assignmentMode = assignmentMode;
                    $tco_var_promotionalItems = disableOldestAnyItem(assignmentMode)(promotionalItems);
                    $copy_promotionalItem = promotionalItem;
                    return;
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($tco_var_dictOrd, $tco_var_assignmentMode, $tco_var_promotionalItems, $copy_promotionalItem);
                };
                return $tco_result;
            };
        };
    };
};
var disableOldestCartItem = /* #__PURE__ */ disableOldest(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isCartPromotionalItem);
var disableOldestProductItem = /* #__PURE__ */ disableOldest(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isProductPromotionalItem);
var enableProductPromotionalItem = function (dictOrd) {
    return function (assignmentMode) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                return function (chooseFrom) {
                    var enabledByUserItems = filterEnabledByUserItems(promotionalItems);
                    var enabledByUserCartItems = Data_Array.filter(Restaumatic_PromotionsEngine_Cart_PromotionalItem.isCartPromotionalItem)(enabledByUserItems);
                    var result = (function () {
                        var $28 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWithAll(promotionalItem)(enabledByUserCartItems);
                        if ($28) {
                            var sourceProductItemKeys = Restaumatic_PromotionsEngine_Cart_PromotionalItem.sourceProductItems(promotionalItem);
                            var disallowedProductItemKeys = Data_Array.concatMap(nonEnableableProductItemKey(promotionalItem))(enabledByUserItems);
                            var sourceItemsFree = Data_Foldable["null"](Data_Foldable.foldableArray)(Data_Array.intersect(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictOrd.Eq0()))(sourceProductItemKeys)(disallowedProductItemKeys));
                            var candidateProductItemKeys = Data_Array.fromFoldable(Data_Set.foldableSet)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.targetProductItemKeys(promotionalItem));
                            var availableProductItemKeys = Data_Array.difference(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictOrd.Eq0()))(candidateProductItemKeys)(disallowedProductItemKeys);
                            var v = chooseFrom(availableProductItemKeys);
                            if (v instanceof Data_Maybe.Just && sourceItemsFree) {
                                return updatePromotionalItem(promotionalItems)(userSelectProductItemKey(dictOrd)(promotionalItem)(v.value0));
                            };
                            var $31 = Data_Foldable["null"](Data_Foldable.foldableArray)(candidateProductItemKeys);
                            if ($31) {
                                return promotionalItems;
                            };
                            return enableProductPromotionalItem(dictOrd)(assignmentMode)(disableOldestProductItem(assignmentMode)(promotionalItems))(promotionalItem)(chooseFrom);
                        };
                        return enableProductPromotionalItem(dictOrd)(assignmentMode)(disableOldestCartItem(assignmentMode)(promotionalItems))(promotionalItem)(chooseFrom);
                    })();
                    return result;
                };
            };
        };
    };
};
var chooseFirstProductItemKey = Data_Array.head;
var enablePromotionalItem = function (dictOrd) {
    return function (assignmentMode) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(promotionalItem));
                if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget) {
                    return enableCartPromotionalItem(dictOrd)(assignmentMode)(promotionalItems)(promotionalItem);
                };
                if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget) {
                    return enableProductPromotionalItem(dictOrd)(assignmentMode)(promotionalItems)(promotionalItem)(chooseFirstProductItemKey);
                };
                throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.UserAction (line 118, column 3 - line 120, column 124): " + [ v.constructor.name ]);
            };
        };
    };
};
var enablePromotionalItemAndRecalculate = function (dictOrd) {
    return function (inputCartData) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                var $33 = Restaumatic_PromotionsEngine_Cart_PromotionalItem.isEnabledByUser(promotionalItem);
                if ($33) {
                    return promotionalItems;
                };
                return Restaumatic_PromotionsEngine_Tools_Assignment.assignPromotionalItems(dictOrd)(inputCartData)(enablePromotionalItem(dictOrd)(Restaumatic_PromotionsEngine_Cart_CartData.assignmentMode(inputCartData))(oldenUserSelections(promotionalItems))(promotionalItem));
            };
        };
    };
};
var maybeEnablePromotionalItem$prime = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(promotionalItem));
            if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget) {
                return maybeEnableCartPromotionalItem(dictOrd)(promotionalItems)(promotionalItem);
            };
            if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget) {
                return maybeEnableProductPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(chooseFirstProductItemKey);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.UserAction (line 76, column 3 - line 78, column 114): " + [ v.constructor.name ]);
        };
    };
};
var maybeEnablePromotionalItem = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            return updateOldenMaybePromotionalItem(promotionalItems)(maybeEnablePromotionalItem$prime(dictOrd)(promotionalItems)(promotionalItem));
        };
    };
};
var maybeEnablePromotionalItemAndRecalculate = function (dictOrd) {
    return function (inputCartData) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                return Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_PromotionsEngine_Tools_Assignment.assignPromotionalItems(dictOrd)(inputCartData))(maybeEnablePromotionalItem(dictOrd)(promotionalItems)(promotionalItem));
            };
        };
    };
};
var chooseAssignmentProductItemKey = function (dictEq) {
    return function (assignment) {
        return function (availableProductItemKeys) {
            return Control_Bind.join(Data_Maybe.bindMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(function (key) {
                return Data_Foldable.find(Data_Foldable.foldableArray)(function (v) {
                    return Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))(v)(key);
                })(Data_Array.fromFoldable(Data_Foldable.foldableArray)(availableProductItemKeys));
            })(Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignmentProductItemKey(assignment)));
        };
    };
};
var maybeEnableAssignPromotionalItem = function (dictOrd) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            return function (assignment) {
                var enabledItemMb = (function () {
                    var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionTarget(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(promotionalItem));
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartTarget) {
                        var $36 = Data_Eq.eq(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItemAssignment(dictOrd.Eq0()))(assignment)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToCart.value);
                        if ($36) {
                            return maybeEnableCartPromotionalItem(dictOrd)(promotionalItems)(promotionalItem);
                        };
                        return Data_Maybe.Nothing.value;
                    };
                    if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductTarget) {
                        return maybeEnableProductPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(chooseAssignmentProductItemKey(dictOrd.Eq0())(assignment));
                    };
                    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.UserAction (line 66, column 5 - line 68, column 134): " + [ v.constructor.name ]);
                })();
                return updateOldenMaybePromotionalItem(promotionalItems)(enabledItemMb);
            };
        };
    };
};
var maybeEnableAssignPromotionalItemAndRecalculate = function (dictOrd) {
    return function (inputCartData) {
        return function (promotionalItems) {
            return function (promotionalItem) {
                return function (assignment) {
                    return Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_PromotionsEngine_Tools_Assignment.assignPromotionalItems(dictOrd)(inputCartData))(maybeEnableAssignPromotionalItem(dictOrd)(promotionalItems)(promotionalItem)(assignment));
                };
            };
        };
    };
};
var changePromotionalItem = function (dictEq) {
    return function (promotionalItems) {
        return function (promotionalItem) {
            return function (input) {
                return updatePromotionalItem(promotionalItems)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.changeInput(dictEq)(promotionalItem)(input));
            };
        };
    };
};
export {
    maybeEnableAssignPromotionalItemAndRecalculate,
    maybeEnablePromotionalItemAndRecalculate,
    maybeEnableAssignPromotionalItem,
    maybeEnablePromotionalItem,
    maybeEnablePromotionalItem$prime,
    disablePromotionalItem,
    changePromotionalItem,
    disablePromotionalItemAndEvaluate,
    enablePromotionalItemAndRecalculate,
    disablePromotionalItemAndRecalculate,
    updatePromotionalItem,
    enablePromotionalItem,
    enableCartPromotionalItem,
    oldenUserSelections,
    disableOldestAnyItem
};
//# sourceMappingURL=index.js.map
